import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  posterBanner: {
    height: "260px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "12px",

    [theme.breakpoints.down("xs")]: {
      height: "170px",
    },
  },
  posterImage: {
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      objectFit: "contain",
    },
  },
}));

export const Banner = ({ img, id }) => {
  const classes = useStyles();

  return (
    <div className={classes.posterBanner}>
      <img
        src={img}
        alt={id}
        className={classes.posterImage}
        draggable={false}
      />
    </div>
  );
};
